import './style.scss'

import React, { FormEvent, useState } from 'react'

import { Button } from '~/components/buttons'

type AvailabilityNotificationProps = {
    onNotify: (email: string) => Promise<void>
}

export const AvailabilityNotification = ({ onNotify }: AvailabilityNotificationProps) => {
    const [email, setEmail] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        setIsSubmitting(true)

        try {
            await onNotify(email)
            setEmail('')
        } catch {
            // The page reports the request error; keep the email so the visitor can retry.
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <section className="public-empty-legs__notify">
            <div>
                <h2>Don’t see your route?</h2>
                <p>We’ll notify you the moment a matching empty leg appears</p>
            </div>
            <form className="public-empty-legs__notify-form" onSubmit={handleSubmit}>
                <input
                    id="empty-leg-notify-email"
                    aria-label="Email address"
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="example@email.com"
                    required
                />
                <Button type="submit" text="Notify me" disabled={isSubmitting} />
            </form>
        </section>
    )
}
